import { FunctionComponent } from 'react'
import Dialog from '@/components/_custom/Dialog/Dialog'
import DialogHeader from '@/components/_custom/DialogHeader/DialogHeader'
import { useTranslation } from 'react-i18next'
import DialogBody from '@/components/_custom/DialogBody/DialogBody'
import styles from './validDeleteSectionDialog.module.scss'
import { useMutation } from '@apollo/client'
import { DELETE_SECTION } from '@/modules/API/daycare/sectionHandler'
import { DaycareType } from '@/types/Daycare'
import ButtonTextIcon from '@/components/_custom/Buttons/ButtonTextIcon/ButtonTextIcon'
import { Close, Delete } from '@mui/icons-material'
import { useNotification } from '@/modules/context/NotificationContext.tsx'

interface ValidDeleteSectionProps {
    open: boolean
    handleClose: () => void
    sectionId: number
    daycareId: number
    daycareType: DaycareType
    refetchSections: () => void
}

const ValidDeleteSectionDialog: FunctionComponent<ValidDeleteSectionProps> = ({
    open,
    handleClose,
    sectionId,
    daycareId,
    daycareType,
    refetchSections
}: ValidDeleteSectionProps) => {
    const { t } = useTranslation()

    const { showNotificationSuccess, showNotificationError } = useNotification()

    const [deleteOneSection] = useMutation(DELETE_SECTION, {
        variables: {
            section_id: sectionId,
            daycare_id: daycareId
        },
        onCompleted: () => {
            showNotificationSuccess(
                daycareType === DaycareType.rpe || daycareType === DaycareType.laep
                    ? t('sectorDeleted')
                    : t('sectionDeleted')
            )
            refetchSections()

            handleClose()
        },
        onError: () => {
            showNotificationError(
                daycareType === DaycareType.rpe || daycareType === DaycareType.laep
                    ? t('errorDeletedSector')
                    : t('errorDeletedSection')
            )
        }
    })

    return (
        <Dialog open={open} handleClose={handleClose} className={styles.Dialog}>
            <DialogHeader
                title={
                    daycareType === DaycareType.rpe || daycareType === DaycareType.laep
                        ? t('confirmDeleteSector')
                        : t('confirmDeleteSection')
                }
            />
            <DialogBody className={styles.DialogBody}>
                <p className={styles.Text}>
                    {daycareType === DaycareType.rpe || daycareType === DaycareType.laep
                        ? t('confirmDeleteSectorMessage')
                        : t('confirmDeleteSectionMessage')}
                </p>
                <div className={styles.ButtonContainer}>
                    <ButtonTextIcon
                        type={'custom'}
                        customIcon={<Delete />}
                        customText={t('yes')}
                        onClick={deleteOneSection}
                        className={styles.Button}
                    />
                    <ButtonTextIcon
                        type={'custom'}
                        customIcon={<Close />}
                        customText={t('no')}
                        onClick={handleClose}
                        className={styles.Button}
                    />
                </div>
            </DialogBody>
        </Dialog>
    )
}

export default ValidDeleteSectionDialog
